export default function setup() {
	window.axios.interceptors.response.use(response => response, error => Promise.reject(error));
}
